//load our custom elements
require("component-leaflet-map");
require("component-responsive-frame");

//get access to Leaflet and the map
var element = document.querySelector("leaflet-map");
var L = element.leaflet;
var map = element.map;

var lines = require("./map.geo.json");

//ICH code for popup template if needed----------
var ich = require("icanhaz");
var templateFile = require("./_popup.html");
ich.addTemplate("popup", templateFile);

var $ = require("jquery");


function zoomToFeature(e) {
    // map.options.maxZoom = 15;
     // map.center(e.target.getCenter());
     // map.options.maxZoom = 20;

    
}

var onEachFeature = function(feature, layer) {
layer.bindPopup(ich.popup(feature.properties));
  layer.on({
    click: zoomToFeature
  });
};

 map.scrollWheelZoom.disable();

 var myStyle = {
    "color": "#A625A4",
    "weight": 3,
    "opacity": 0.75
};

var geojson = L.geoJson(lines, {
    style: myStyle
}).addTo(map);

 map.fitBounds(geojson.getBounds());

  var myStyle2 = {
    "color": "#A625A4",
    "weight": 20,
    "opacity": 0.15
};

 var highlight = L.geoJson(lines, {
    style: myStyle2,
        onEachFeature: onEachFeature
}).addTo(map);

 var zoomValues = {
  pioneersquare: "Pioneer Square",
  chinatown: "Chinatown International District",
  downtown: "Downtown Seattle",
  university: "University District",
  southlake: "South Lake Union",
  capitolhill: "Capitol Hill"
};

 $(".zoom-button").click(function() {

  // $("#menu a.selected").removeClass("selected");
  // $(this).addClass("selected");
  var zoom = $(this).data("zoom");

var zoomValue = zoomValues[zoom];

    var neighborhood = L.geoJson(lines, {
            filter: function(feature, layer) {
                return feature.properties.district == zoomValue;
            }
        });

  map.fitBounds(neighborhood.getBounds(), {
            maxZoom: 17
        });
});




